export default __webpack_public_path__ + "d4a85f2a5ada22698a7ea4c7a544cb6c.svg";